import Vue from "vue";
import Router from "vue-router";
import i18n from "./i18n/i18n";
import home from "./pages/home";

Vue.use(Router);
var pageTitle = localStorage.getItem("appType");
const constantRouterMap = [
  {
    name: "index",
    path: "/",
    redirect: "/home",
  },
  {
    name: "home",
    path: "/home",
    component: home,
    meta: {
      keepAlive: true,
      title: pageTitle || "HoneyCam",
    },
  },
];

export default new Router({
  // mode: 'history', //后端支持可开
  // scrollBehavior: () => ({
  //     y: 0
  // }),
  routes: constantRouterMap,
});
